module.exports = __webpack_public_path__ + "static/media/grin.40c03fec.svg";